import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'library.new.error': {
    defaultMessage: 'Failed to create library',
    id: 'library.new.error'
  },
  'library.new.pageTitle': {
    defaultMessage: 'Create Library',
    id: 'library.new.pageTitle'
  },
  'library.new.success': {
    defaultMessage: 'Created Library',
    id: 'library.new.success'
  }
});
